<template>
  <div>
    <table class="ranking" v-if="filteredRanking && filteredRanking.length > 0">
        <thead>
            <tr class="">
                <th></th>
                <th></th>
                <th class="team_name_header"></th>
                <th class="last_stat">Pts</th>
                <th>J.</th>
                <th>G.</th>
                <th>N.</th>
                <th class="last_stat">P.</th>
                <th>Td.+</th>
                <th class="last_stat">Td.-</th>
                <th>Sor.+</th>
                <th class="last_stat">Sor.-</th>
                <th class="last_stat">Agro</th>
                <th>Réu</th>
                <th class="last_stat">coach</th>

            </tr>
        </thead>
        <tbody>
            <tr v-for="ranking_line,i of filteredRanking"  :id="ranking_line.team_id" @click="teamClicked(ranking_line.team_id)">
                <td v-if="i<9" class="win" >{{i+1}}.</td>
                <td v-else="i>=9" class="lose" >{{i+1}}.</td>
                <td class="icon"><img class="team-icon" :src="getRosterIcon(ranking_line.ref_roster_name)" alt="team"></td>
                <td class="team_name">{{ranking_line.name}}</td>
                <td class="points last_stat">{{ranking_line.ranking_points}}</td>
                <td>{{ranking_line.played}}</td>
                <td>{{ranking_line.won}}</td>
                <td>{{ranking_line.drew}}</td>
                <td class="last_stat">{{ranking_line.lost}}</td>
                <td >{{ranking_line.td_for}}</td>
                <td class="last_stat">{{ranking_line.td_against}}</td>
                <td >{{ranking_line.cas_for}}</td>
                <td class="last_stat">{{ranking_line.cas_against}}</td>
                <td class="last_stat">{{ranking_line.aggro}}</td>
                <td class="">{{ranking_line.passes}}</td>
                <td class="last_stat">{{ranking_line.username}}</td>
            </tr>
        </tbody>
    </table>
    <h4 v-else> Pas de matchs encore saisis</h4>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'

export default {
  name: 'detailedRanking',
  components: {
    spinner
  },
  data () {
    return {
    }
  },
  props: {
    'rankingGroup': null,
    'selectedWeek': null
  },
  computed: {
    ...mapGetters([
      'ranking'
    ]),
    filteredRanking: function () {
      return store.getters.orderedRankingForGroupAndDay(this.rankingGroup.id, this.selectedWeek.id)
    }
  },
  methods: {
    previous () {
      this.$router.push({name: 'mrStep5', params: { id: this.id }})
    },
    teamClicked (teamId) {
      let t = teamId.toString()
      this.$router.push({name: 'TeamDetail', params: { id: t }})
    },
    getRosterIcon (roster) {
      return '/static/imgs/team-icons/' + roster.replace(/\s+/, '') + '.png'
    }
  },
  created () {
    // store.dispatch('getRanking')
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
/**************** general  */
table{
    border-collapse: separate;
}

.ranking{
    font-weight: 300;
    font-size: 0.8rem;
}

.trend-icon-up {
    color: #009900;
    -ms-transform: rotate(-45deg); /* IE 9 */
    -webkit-transform: rotate(-45deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
    padding-right: 0rem 0.5rem
}

.trend-icon-down {
    color: #CC0000;
    -ms-transform: rotate(-135deg); /* IE 9 */
    -webkit-transform: rotate(-135deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
    padding-right: 0rem 0.5rem
}

.trend-icon-neutral {
    color: #BBBBBB;
    -ms-transform: rotate(-90deg); /* IE 9 */
    -webkit-transform: rotate(-90deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
    padding-right: 0rem 0.5rem
}

.ranking tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.ranking tr:nth-of-type(even) {
    background-color: #ffffff;
}

.ranking tr:hover{
    background-color: #D1DBEB;
    cursor: pointer;
}


/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
}

.ranking tr td{
    padding: 0.3rem 0.5rem;
    text-align: center;
}

.ranking tr td.icon {
    padding: 0rem;
    text-align: center;
}

.ranking tr td.rank{
    padding: 0rem 0.5rem
}

thead tr th.team_name_header{
    padding-left: 0.5rem;
    padding-right: 3rem;
    text-align:left;
}

.ranking tr td.team_name{
    padding: 0rem 0.5rem;
    padding-left: 1rem;
    padding-right: 3rem;
    text-align:left;
    font-weight: 200;
}

.ranking tr td.points{
    font-weight: 400;
}

.team-icon{
    width: 25px;
    height: 25px;
    margin-bottom: 0;
}

/**************** ranking */

.ranking tr td.points {
    padding-right: 3rem;
}

thead tr th.last_stat,
.ranking tr td.last_stat {
    padding-right: 1.8rem;
}

.win {
    border-left-style: solid;
    border-left-width: 4px;
    border-left-color: #009900;
}

.lose {
    border-left-style: solid;
    border-left-width: 4px;
    border-left-color: #CC0000;
}

/********* Onglets ***********/

.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
}

.tabs li{
    float: left;
    margin-left : 0rem;
    padding : 0.4rem 0.8rem ;
    margin-right : 0rem;
    position: relative;
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
}

.tabs li:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li.active {
    border: 1px solid #cacaca;
    border-bottom: 2px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
    bottom: -1px
}

</style>



// WEBPACK FOOTER //
// detailed-ranking.vue?a5ccb56c